import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, Download } from 'lucide-react';

// Full-size image viewer; click anywhere / Esc to close
export const ImageLightbox = ({ url, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [onClose]);
  if (!url) return null;
  return createPortal(
    <div className="fixed inset-0 z-[70] bg-black/90 flex items-center justify-center p-4 cursor-zoom-out" onClick={onClose} data-testid="image-lightbox">
      <img src={url} alt="" className="max-w-full max-h-full object-contain rounded shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="image-lightbox-img" />
      <div className="absolute top-4 right-4 flex gap-2" onClick={(e) => e.stopPropagation()}>
        <a href={url} target="_blank" rel="noreferrer" className="h-9 w-9 flex items-center justify-center rounded-full bg-zinc-900/80 text-zinc-200 hover:text-amber-400" title="Open original" data-testid="image-lightbox-open"><Download className="w-4 h-4" /></a>
        <button onClick={onClose} className="h-9 w-9 flex items-center justify-center rounded-full bg-zinc-900/80 text-zinc-200 hover:text-amber-400" data-testid="image-lightbox-close"><X className="w-4 h-4" /></button>
      </div>
    </div>,
    document.body
  );
};

export default ImageLightbox;
